var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{class:[
    'container', _vm.isCentered ? 'centered' : '', 
    _vm.isFullScreen ? 'fullscreen' : ''
  ],style:({
    maxWidth: _vm.width,
    paddingLeft: _vm.bleedPaddingSize,
    paddingRight: _vm.bleedPaddingSize
  }),attrs:{"direction":(_vm.isFullScreen || _vm.isHorizontal) ? 'horizontal' : 'vertical'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }